import { IntlShape } from "react-intl";
import { FORM_VALIDATION_MESSAGES } from "../../constants/form.constants";

export const getRequiredRule = (label: string, intl: IntlShape) => {
    return {
        required: true,
        message: intl.formatMessage(FORM_VALIDATION_MESSAGES.required, { "label": label })
    };
};